import { useMutation } from 'react-query';

import { updateProjectDetails } from 'shared/api/projects/http';

const useMutateUpdateProjectDetails = (options = undefined) =>
  useMutation(({ id, details }) => updateProjectDetails(id, details), options);

export default useMutateUpdateProjectDetails;
